import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Tax, type TaxConstructor } from './Tax'

export const TaxConstructorFactory = Factory.Sync.makeFactory<TaxConstructor>({
  id: Factory.each(() => faker.random.number()),
  description: Factory.each(() => faker.lorem.words()),
  isActive: true,
  isDefault: false,
  isInclusive: false,
  name: Factory.each(() => faker.commerce.productName()),
  percentage: Factory.each(() => (faker.random.number(100) / 100).toString()),
})

export const TaxFactory = EntityFactory(Tax, TaxConstructorFactory)
